import Vue from "vue";
import Router from "vue-router";
import i18n from "@/i18n";

Vue.use(Router);

const originalPush = Router.prototype.push;

Router.prototype.push = function push(location, resolve, reject) {
	if (resolve || reject) {
		return originalPush.call(this, location, resolve, reject);
	}

	return originalPush.call(this, location).catch((_e) => {
		// empty
		// eslint-disable-next-line no-console
		// console.error(error);
	});
};

export const menuRoutes = [
	{
		path: "/styleManage",
		name: "StyleManage",
		meta: {
			title: i18n.tc("styleManage"),
			icon: "icon-a-iconsksgl"
		},
		children: [
			{
				path: "/styleManage/developmentVersion",
				name: "DevelopmentVersion",
				meta: {
					title: i18n.tc("developmentVersion"),
					permission: "apc/board.board/index"
				},
				component: (resolve) => require(["@/views/StyleManage/DevelopmentVersion"], resolve)
			},
			{
				path: "/styleManage/estimatedQuotation",
				name: "EstimatedQuotation",
				meta: {
					title: i18n.tc("preQuotation"),
					markerKey: "estimated_quotation",
					permission: "apc/board.estimatedQuotation/index"
				},

				component: (resolve) => require(["@/views/StyleManage/EstimatedQuotation"], resolve)
			},
			{
				path: "/styleManage/patternAllocationOrder",
				name: "PatternAllocationOrder",
				meta: {
					title: i18n.tc("patternAllocationOrder"),
					markerKey: "allocation_order",
					permission: "apc/board.allocationOrder/index"
				},

				component: (resolve) => require(["@/views/StyleManage/PatternAllocationOrder"], resolve)
			},
			{
				path: "/styleManage/reviewVersion",
				name: "ReviewVersion",
				meta: {
					title: i18n.tc("reviewVersion"),
					markerKey: "process_board",
					permission: "apc/board.processBoard/index"
				},
				component: (resolve) => require(["@/views/StyleManage/ReviewVersion"], resolve)
			},
			{
				path: "/styleManage/recheckBom",
				name: "RecheckBom",
				meta: {
					title: i18n.tc("recheckBom"),
					markerKey: "check_bom",
					permission: "apc/board.checkBom/index"
				},
				component: (resolve) => require(["@/views/StyleManage/RecheckBom"], resolve)
			}
		]
	},
	{
		path: "/commodityCenter",
		name: "CommodityCenter",
		meta: {
			icon: "icon-a-iconsspzx",
			title: i18n.tc("commodityCenter"),
			permission: "apc/goods.goods/index"
		},
		component: (resolve) => require(["@/views/CommodityCenter"], resolve)
	},
	{
		path: "/basicsInfo",
		name: "BasicsInfo",
		meta: {
			title: i18n.tc("basicsInfo"),
			icon: "el-icon-office-building",
			// 仅仅只是一个菜单，不需要在路由中加载
			onlyMenu: true
		},
		children: [
			{
				path: "/basicsInfo/sizeRecord",
				name: "SizeRecord",
				meta: {
					title: i18n.tc("sizeRecord"),
					permission: "apc/base.size/index"
				},
				component: (resolve) => require(["@/views/BasicsInfo/SizeRecord"], resolve)
			},
			{
				path: "/basicsInfo/partialMeasurement",
				name: "PartialMeasurement",
				meta: {
					title: i18n.tc("partialMeasurement"),
					permission: ["apc/base.measurementPoint/index"]
				},
				component: (resolve) => require(["@/views/BasicsInfo/PartialMeasurement"], resolve)
			},
			{
				path: "/basicsInfo/surfaceMaterials",
				name: "SurfaceMaterials",
				meta: {
					title: i18n.tc("surfaceMaterials"),
					permission: "apc/base.material/index"
				},
				component: (resolve) => require(["@/views/BasicsInfo/SurfaceMaterials"], resolve)
			},
			{
				path: "/basicsInfo/supplierInfor",
				name: "SupplierInfor",
				meta: {
					title: i18n.tc("supplierInfo"),
					permission: "apc/base.supplier/index"
				},
				component: (resolve) => require(["@/views/BasicsInfo/SupplierInfor"], resolve)
			},
			{
				path: "/basicsInfo/designcategory",
				name: "DesignCategory",
				meta: {
					title: i18n.tc("designCategory"),
					permission: "apc/base.styleCategoryDetail/lists"
				},
				component: (resolve) => require(["@/views/BasicsInfo/DesignCategory"], resolve)
			},
			{
				path: "/basicsInfo/technology",
				name: "Technology",
				meta: {
					title: i18n.tc("technologyManage"),
					permission: "apc/base.processSheets/index"
				},
				component: (resolve) => require(["@/views/BasicsInfo/Technology"], resolve)
			},
			{
				path: "/basicsInfo/processManagement",
				name: "ProcessManagement",
				meta: {
					title: i18n.tc("processManage"),
					permission: "apc/base.sewing/index"
				},
				component: (resolve) => require(["@/views/BasicsInfo/ProcessManagement"], resolve)
			},
			{
				path: "/basicsInfo/pattern",
				name: "Pattern",
				meta: {
					title: i18n.tc("patternStudio"),
					permission: "apc/base.patternStudio/index"
				},

				component: (resolve) => require(["@/views/BasicsInfo/Pattern"], resolve)
			},

			{
				path: "/basicsInfo/department",
				name: "Department",
				meta: {
					title: i18n.tc("departmentManage"),
					permission: "apc/base.department/index"
				},
				component: (resolve) => require(["@/views/BasicsInfo/Department"], resolve)
			}
		]
	},
	{
		path: "/basicSettings",
		name: "BasicSettings",
		meta: {
			title: i18n.tc("basicSettings"),
			icon: "icon-a-iconsxtpz",
			// 仅仅只是一个菜单，不需要在路由中加载
			onlyMenu: true
		},
		children: [
			{
				path: "/basicSettings/accountPermissions",
				name: "AccountPermissions",
				meta: {
					title: i18n.tc("accountPermissions"),
					permission: ["apc/system.admin/index", "apc/system.auth/index"]
				},
				component: (resolve) => require(["@/views/BasicSettings/AccountPermissions"], resolve)
			},
			{
				path: "/basicSettings/systemConfig",
				name: "SystemConfig",
				meta: {
					title: i18n.tc("systemConfig"),
					permission: [
						"apc/system.setting.divideSetting/index",
						"apc/system.setting.currency/index",
						"apc/system.setting.bomRatio/index",
						"apc/system.setting.versionReview/index",
						"apc/system.setting.shop/index"
					]
				},
				component: (resolve) => require(["@/views/BasicSettings/SystemConfig"], resolve)
			}
		]
	}
];

export const headquartersSetupRoutes = {
	path: "/headquartersSetup",
	name: "HeadquartersSetup",
	meta: {
		title: i18n.tc("headquarters")
	},
	component: (resolve) => require(["@/layout/HeadquartersSetup"], resolve),
	redirect: "/headquartersSetup/versionRoomManage",
	children: [
		{
			path: "/headquartersSetup/versionRoomManage",
			name: "VersionRoomManage",
			meta: {
				icon: "icon-banfang",
				title: i18n.tc("versionRoomManage")
			},
			component: (resolve) => require(["@/views/HeadquartersSetup/VersionRoomManage"], resolve)
		},
		{
			path: "/headquartersSetup/permissionManage",
			name: "PermissionManage",
			meta: {
				icon: "icon-xtpz",
				title: i18n.tc("permissionManage")
			},
			component: (resolve) => require(["@/views/HeadquartersSetup/PermissionManage"], resolve)
		},
		{
			path: "/headquartersSetup/accountManage",
			name: "AccountManage",
			meta: {
				icon: "icon-zhqx",
				title: i18n.tc("accountManage")
			},
			component: (resolve) => require(["@/views/HeadquartersSetup/AccountManage"], resolve)
		}
	]
};

const defaultRouter = [
	{
		path: "*",
		name: "404",
		meta: {
			title: i18n.tc("pageNotFound")
		},
		component: (resolve) => require(["@/views/404.vue"], resolve)
	},
	{
		path: "/login",
		name: "Login",
		meta: {
			title: i18n.tc("login")
		},
		component: (resolve) => require(["@/views/Login"], resolve)
	},
	{
		path: "/",
		name: "root",
		component: (resolve) => require(["@/layout"], resolve),
		children: []
	}
];

export default new Router({
	mode: "history",
	base: process.env.BASE_URL,
	routes: defaultRouter
});
